import { ALL_STATES, STATES } from "../../../constants/states";

// elementType = segment/actionSegment are just a fancy names given to the form section divider mentioned in formSchema config
// this is just to allow array iterator to differentiate b/w a form field and some other stuff
// like sub form heading or a subform heading along with some action control btn.

export const INITIAL_VALUES = {
  address: {
    city: "",
    state: "",
    street: "",
    zip_code: "",
  },
  ConfirmPassword: "",
  dob: "",
  emergency_contact_number: "",
  emergency_contact_person: "",
  first_name: "",
  gender: "",
  insurance: {
    card_back: "",
    card_front: "",
    carrier: "",
    group_id: "",
    member_id: "",
    policy_dob: "",
    policy_holder_name: "",
    policy_holder_question: "yes",
    policy_relationship: "self",
    state: "",
  },
  last_name: "",
  mobile: "",
  Password: "",
  pcp_id: "",
  pcp_name: "",
  preferences: { is_sms_enabled: false },
  referralCode: "",
  Username: "",
};

export const PRIMARY_PATIENT_INFORMATION_SCHEMA = [
  {
    elementConfig: {
      label: "First Name",
      placeholder: "First name",
      type: "text",
    },
    elementType: "input",
    name: "first_name",
    testLocatorId: "signUpFirstNameInput",
  },
  {
    elementConfig: {
      label: "Last Name",
      placeholder: "Last name",
      type: "text",
    },
    elementType: "input",
    name: "last_name",
    testLocatorId: "signUpLastNameInput",
  },
  {
    elementConfig: {
      label: "Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    formatted: true,
    name: "dob",
    testLocatorId: "signUpDobInput",
  },
  {
    elementConfig: {
      label: "Gender",
      options: [
        { display: "Gender", selected: true, value: "" },
        { display: "Male", value: "male" },
        { display: "Female", value: "female" },
      ],
      placeholder: "Gender",
    },
    elementType: "select",
    name: "gender",
    testLocatorId: "signUpGenderSelect",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    formatted: true,
    name: "mobile",
    testLocatorId: "signUpMobileInput",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "Username",
    testLocatorId: "signUpEmailInput",
  },
  {
    elementConfig: {
      label: "Create Password",
      placeholder: "Password",
      type: "password",
    },
    elementType: "input",
    name: "Password",
    testLocatorId: "signUpPasswordInput",
  },
  {
    elementConfig: {
      label: "Confirm Password",
      placeholder: "Confirm Password",
      type: "password",
    },
    elementType: "input",
    name: "ConfirmPassword",
    testLocatorId: "signUpConfirmPasswordInput",
  },
];

export const PATIENT_ADDRESS_SCHEMA = (interestedInGuardianship) => [
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  {
    displayName: "Address",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "Street",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
    testLocatorId: "signUpStreetInput",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
    testLocatorId: "signUpCityInput",
  },
  {
    elementConfig: {
      label: "State",
      options: interestedInGuardianship ? ALL_STATES : STATES,
      placeholder: "Enter State",
    },
    elementType: "select",
    name: "address.state",
    testLocatorId: "signUpStateSelect",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
    testLocatorId: "signUpZipInput",
  },
];

export const EMERGENCY_CONTACT_SCHEMA = [
  {
    elementConfig: {
      label: "Emergency Contact Person",
      placeholder: "Emergency Contact Person",
      type: "text",
    },
    elementType: "input",
    name: "emergency_contact_person",
    testLocatorId: "signUpEmergencyContactInput",
  },
  {
    elementConfig: {
      label: "Emergency Contact Number",
      placeholder: "Emergency Contact Number",
      type: "text",
    },
    elementType: "input",
    formatted: true,
    name: "emergency_contact_number",
    testLocatorId: "signUpEmergencyNumberInput",
  },
];
